import LoadingSkeleton from "./LoadingSkeleton";
export default {
  name: "PageLoading",
  components: {
    LoadingSkeleton
  }
};